<div class="container">
	<form [formGroup]="formGroup">
		<div class="container__tab-form">
			<div class="container__form-row">
				<lawyal-dropdown-input
					class="container__input"
					[options]="recurringOptions"
					[formControlName]="RECURRING_OPTIONS_CONTROL"
					(change)="onRecurringOptionChange($event)"
				></lawyal-dropdown-input>
				<div class="container__inputs-wrapper">
					<free-text-input
						class="container__input"
						[formControlName]="REMINDER_INTERVAL_CONTROL"
						[placeholder]="translation.INTERVAL"
						[label]="translation.INTERVAL"
						[inputType]="inputType.Number"
						[required]="!isOneTimeReminder()"
					>
					</free-text-input>
					<lawyal-autocomplete
						class="container__input container__input--last-in-row"
						[formControlName]="REMINDER_OCCURRENCE_CONTROL"
						[placeholder]="translation.OCCURRENCE"
						[label]="translation.OCCURRENCE"
						[isPaginated]="true"
						[optionsCallback]="tasksRemindersOccurrenceTypesOptionsCallback"
						[required]="!isOneTimeReminder()"
					>
					</lawyal-autocomplete>
				</div>
			</div>
			<div class="container__form-row">
				<datepicker-input
					class="container__input"
					[formControlName]="REMINDER_DATE_START_CONTROL"
					[placeholder]="translation.DATE_START"
					[label]="translation.DATE_START"
					[required]="!isOneTimeReminder()"
				>
				</datepicker-input>
				<time-picker-input
					class="container__input container__input--last-in-row"
					[formControlName]="REMINDER_TIME_START_CONTROL"
					[placeholder]="translation.TIME_START"
					[label]="translation.TIME_START"
					[hint]="translation.HOUR_HINT"
					[required]="!isOneTimeReminder()"
				></time-picker-input>
			</div>
			<div class="container__form-row">
				<datepicker-input
					class="container__input"
					[formControlName]="REMINDER_DATE_END_CONTROL"
					[placeholder]="translation.DATE_END"
					[label]="translation.DATE_END"
				>
				</datepicker-input>
				<time-picker-input
					class="container__input container__input--last-in-row"
					[formControlName]="REMINDER_TIME_END_CONTROL"
					[placeholder]="translation.TIME_END"
					[label]="translation.TIME_END"
					[hint]="translation.HOUR_HINT"
				></time-picker-input>
			</div>
			<div class="container__form-row">
				<lawyal-autocomplete
					class="container__input"
					[formControlName]="REMINDER_NOTIFICATION_TYPE_CONTROL"
					[placeholder]="translation.NOTIFICATION_TYPE"
					[label]="translation.NOTIFICATION_TYPE"
					[isPaginated]="false"
					[optionsCallback]="tasksRemindersInAppTypesOptionsCallback"
				>
				</lawyal-autocomplete>
				<lawyal-autocomplete
					class="container__input container__input--last-in-row"
					[formControlName]="REMINDER_RECIPIENTS_CONTROL"
					[placeholder]="translation.RECIPIENTS"
					[label]="translation.RECIPIENTS"
					[isPaginated]="true"
					[isMultipleSelection]="true"
					[optionsCallback]="usersOptionsCallback"
				>
				</lawyal-autocomplete>
			</div>
			<div class="container__form-row">
				<textarea-input
					class="container__input container__textarea container__input--last-in-row"
					[formControlName]="REMINDER_NOTES_CONTROL"
					[placeholder]="translation.NOTES"
					[label]="translation.NOTES"
				>
				</textarea-input>
			</div>
			<div class="container__tab-buttons-wrapper">
				<submit-button
					data-testid="close-reminder-form-button"
					class="container__tab-button"
					[title]="translation.CANCEL"
					(onClick)="onAction(reminderActionsEnum.Cancel)"
				>
				</submit-button>
				<submit-button
					data-testid="add-reminder-form-button"
					class="container__tab-button"
					[title]="translation.SAVE"
					[filled]="true"
					(onClick)="onAction(reminderActionsEnum.Save)"
				>
				</submit-button>
			</div>
		</div>
	</form>
</div>
